/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Not_StartedInputs */

const en_mobile_not_started = /** @type {(inputs: Mobile_Not_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not started`)
};

const es_mobile_not_started = /** @type {(inputs: Mobile_Not_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No iniciado`)
};

/**
* | output |
* | --- |
* | "Not started" |
*
* @param {Mobile_Not_StartedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_not_started = /** @type {((inputs?: Mobile_Not_StartedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Not_StartedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_not_started(inputs)
	return en_mobile_not_started(inputs)
});